import { FC } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import Button from '@/storybook/components/Button/Button';
import Dialog from '@/storybook/components/Dialog/Dialog';
import { UserFilterListItem } from '@/models/user/userFilter';

import styles from './DeleteFilterDialog.module.css';

interface DeleteFilterDialogProps {
  isOpen: boolean;
  isLoading: boolean;
  filter: UserFilterListItem | null;
  onConfirm: () => void | Promise<void>;
  onCancel: () => void;
}

const DeleteFilterDialog: FC<DeleteFilterDialogProps> = ({ isOpen, isLoading, filter, onConfirm, onCancel }) => {
  const { t } = useTranslation();

  if (!filter) return null;

  const filterName = filter.filterName ?? filter.userFilterId;

  const footer = (
    <>
      <Button variant="outlined" onClick={onCancel} disabled={isLoading} data-testid="delete-filter-cancel">
        {t('global.filters.manageSavedFilters.deleteCancel')}
      </Button>
      <Button
        variant="primary"
        color="warning"
        onClick={onConfirm}
        disabled={isLoading}
        loading={isLoading}
        data-testid="delete-filter-confirm"
      >
        {t('global.filters.manageSavedFilters.deleteConfirm')}
      </Button>
    </>
  );

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onCancel}
      title={t('global.filters.manageSavedFilters.deleteTitle')}
      size="S"
      footer={footer}
      className={styles.dialogOverflowFix}
      data-testid="delete-filter-dialog"
    >
      <p className={styles.message}>
        <Trans
          i18nKey="global.filters.manageSavedFilters.deleteMessage"
          values={{ filterName }}
          components={{ bold: <strong /> }}
        />
      </p>
    </Dialog>
  );
};

export default DeleteFilterDialog;
